import { User } from "core/types/user.types";
import { ApiFactoryClients } from "../api.types";
import { transformUser, transformUserAdmin } from "./code.helpers";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  getUser: () =>
    codeHttpClient.get("/account").then(({ data }) => transformUser(data)),
  getUsers: () =>
    codeHttpClient
      .get("/admin/users")
      .then(({ data }) => data?.map((d: any) => transformUserAdmin(d))),
  saveUser: (body: {
    id: string;
    level: string;
    report_count: number;
    searches_count: number;
    tokens_count: number;
  }) => codeHttpClient.put(`/admin/users`, body),
  getUsageLog: (params?: {
    user_id?: string;
    action?: string;
    from?: string;
    to?: string;
    limit?: number;
  }) =>
    codeHttpClient
      .get("/admin/usage", { params })
      .then(({ data }) => data as any[]),
});
